import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Autocomplete } from "@mui/material";
import { decryptAesObj } from "../CommonComponents/AESencryptdecrypt";
import ValidationTextField from "../CommonComponents/CommanInputeField";
import { validateField } from "../CommonComponents/validation/validation";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "none",
    border: "none",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    //  border: "2px solid #000",
    // boxShadow: theme.shadows[5],
    //padding: theme.spacing(2, 4, 3),
    outline: "none",
    border: "none",
    width: "390px",
    borderRadius: "10px",
  },
}));

export default function CahngePasswordModal({
  passwordModalOpen,
  setPasswordModalOpen,
  currentPassword,
  newPassword,
  confirmPassword,
  setcurrentPassword,
  setnewPassword,
  setconfirmPassword,
  changepasswordhandler,
  Closechangepassword,
  checkValidation, 
  setCheckValidation
}) {
  const [showErrorMesage, setShowErrorMesage] = useState({
    oldError: "",
    oldMessage: "",
    newError: "",
    newMessage: "",
    conError: "",
    conMessage: "",
  });
  const lowercaseRegex = /[a-z]/;
  const uppercaseRegex = /[A-Z]/;
  const digitRegex = /\d/;
  const specialCharRegex = /[@$!%*?&]/;
  const minLengthRegex = /.{8,}/;


  const classes = useStyles();
  const onChangehandler = (event) => {
    const { name, value } = event.target;

    if (name === "currentPassword") {
      setcurrentPassword(value);
    } else if (name === "newPassword") {
      setnewPassword(value);
      if (validatePassword(value)) {
        setShowErrorMesage({
          newError: true,
          newMessage: validatePassword(value),
        });
        setCheckValidation(true)
      }
      else{
        setShowErrorMesage({
          newError: false,
          newMessage: "",
        });
        setCheckValidation(false)
      }
    } else if (name === "confirmPassword") {
      setconfirmPassword(value);
      if (validatePassword(value)) {
        setShowErrorMesage({
          conError: true,
          conMessage: validatePassword(value),
        });
        setCheckValidation(true)
      }
      else{
        setShowErrorMesage({
          conError: false,
          conMessage: "",
        });
        setCheckValidation(false)
      }
    }
  };

  const validatePassword = (password) => {
    let errors ='';

    if (!lowercaseRegex.test(password)) {
      errors='Password must contain at least one lowercase letter.';
    }
    if (!uppercaseRegex.test(password)) {
      errors='Password must contain at least one uppercase letter.';
    }
    if (!digitRegex.test(password)) {
      errors='Password must contain at least one digit.';
    }
    if (!specialCharRegex.test(password)) {
      errors='Password must contain at least one special character (@$!%*?&).';
    }
    if (!minLengthRegex.test(password)) {
      errors='Password must be at least 8 characters long.';
    }

    return errors;
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={passwordModalOpen}
        onClose={Closechangepassword}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={passwordModalOpen}>
          <div className={classes.paper}>
            <div
              style={{
                background: "#907ea5",
                borderTopRightRadius: "10px",
                borderTopLeftRadius: "10px",
              }}
            >
              <Grid
                container
                direction="row"
                //alignItems="flex-start"
                justifyContent="space-between"
                spacing={1}
                item={12}
              >
                <Grid item={5}>
                  <h5
                    id="transition-modal-title"
                    style={{ marginLeft: "10px", marginTop: "10px" }}
                  >
                    Change Password
                  </h5>
                </Grid>
                <Grid item={3} justifyContent="flex-end">
                  <IconButton onClick={Closechangepassword}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
                item={12}
              >
                <Grid
                  item={12}
                  style={{
                    marginTop: "10px",
                    marginLeft: "10px",
                    width: "70%",
                  }}
                ></Grid>

                <Grid item={12} style={{ marginLeft: "10px", width: "90%" }}>
                  <Typography>
                    <Typography>Old Password</Typography>

                    <ValidationTextField
                      className="user"
                      id="datetime-local"
                      name="currentPassword"
                      type="password"
                      value={currentPassword}
                      onChange={(e) => onChangehandler(e)}
                      variant="outlined"
                      error={showErrorMesage.oldError}
                      helperText={showErrorMesage.oldMessage}
                    />
                  </Typography>
                </Grid>
                <Grid item={12} style={{ marginLeft: "10px", width: "90%" }}>
                  <Typography>
                    <Typography>New Password</Typography>

                    <ValidationTextField
                      className="user"
                      id="datetime-local"
                      name="newPassword"
                      type="password"
                      value={newPassword}
                      onChange={(e) => onChangehandler(e)}
                      variant="outlined"
                      style={{ backgroundColor: "white" }}
                      error={showErrorMesage.newError}
                      helperText={showErrorMesage.newMessage}
                    />
                  </Typography>
                </Grid>
                <Grid item={12} style={{ marginLeft: "10px", width: "90%" }}>
                  <Typography>
                    <Typography>Confirm Password</Typography>

                    <ValidationTextField
                      className="user"
                      id="datetime-local"
                      name="confirmPassword"
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => onChangehandler(e)}
                      variant="outlined"
                      style={{ backgroundColor: "white" }}
                      error={showErrorMesage.conError}
                      helperText={showErrorMesage.conMessage}
                    />
                  </Typography>
                </Grid>

                <Grid
                  item={3}
                  style={{
                    margin: "10px 10px",
                    position: "relative",
                    left: "68%",
                  }}
                >
                  <Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={changepasswordhandler}
                    >
                      Update
                    </Button>
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
